import { Box, Button, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useIdCheckFlow } from '../../../../logic'
import { useLocation } from 'react-router-dom'
import { ErrorDialog } from '../../dialogs/ErrorDialog'
import { useGetNotification } from '../../../../logic/useApiQuery'

export function IdCheckTask({ orderKey, notificationId }: {
  orderKey: string,
  notificationId: string,
}) {
  const { search } = useLocation()
  const { data: notification } = useGetNotification({ notificationId })
  const {
    idCheckUrl,
    isPolling,
    getIdCheckUrlLoading,
    handleIdCheckClick,
    startPolling,
    isComplete,
    error
  } = useIdCheckFlow(orderKey, notificationId, search)

  if (isComplete) {
    return null
  }

  if (error) {
    return <ErrorDialog error='There was an error processing your request.' tryAgainText='Reload and try again' />
  }

  const bankName = notification?.Configuration?.SecondaryAccountVerificationConfig?.BankName
  const routingNumber = notification?.Configuration?.SecondaryAccountVerificationConfig?.RoutingNumber
  const maskedAccountNumber = notification?.Configuration?.SecondaryAccountVerificationConfig?.MaskedAccountNumber

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
      }}
    >
      {routingNumber && maskedAccountNumber && (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <Typography variant="body1">
            Please confirm you wish to submit the following account information:
            <br/><br/>
            Bank Name: <strong style={{wordBreak: 'break-all'}}>{bankName}</strong>
            <br/>
            Routing Number: <strong>{routingNumber}</strong>
            <br/>
            Account Number: <strong>{maskedAccountNumber}</strong>
            <br/><br/>
            Click verify your identity to complete your account submission.
          </Typography>
        </Box>
      )}

      <LoadingButton
        loading={getIdCheckUrlLoading}
        variant="contained"
        sx={{
          borderRadius: "40px",
          minWidth: "250px",
        }}
        onClick={handleIdCheckClick}
      >
        Verify your identity
      </LoadingButton>

      {idCheckUrl && !isPolling && (
        <Button
          variant="outlined"
          sx={{
            borderRadius: "40px",
            minWidth: "250px",
          }}
          onClick={startPolling}
        >
          I've completed verification
        </Button>
      )}

      {idCheckUrl && (
        <Box sx={{ mt: 2 }}>
          If a new window did not open you can allow pop-ups or&nbsp;
          <a href={idCheckUrl} target='_blank' rel='noreferrer'>
            click here to verify your identity in a new window.
          </a>
        </Box>
      )}
    </Box>
  )
}
